// This file is autogenerated. DO NOT MODIFY

export const EORA_NUMBERS = {
  BASE: {
    UNITS: {
      UNIT_0: 0,
      UNIT_0P125: 1,
      UNIT_0P25: 2,
      UNIT_0P375: 3,
      UNIT_0P5: 4,
      UNIT_0P75: 6,
      UNIT_0P875: 7,
      UNIT_1: 8,
      UNIT_1P125: 9,
      UNIT_1P25: 10,
      UNIT_1P5: 12,
      UNIT_1P75: 14,
      UNIT_2: 16,
      UNIT_2P25: 18,
      UNIT_2P5: 20,
      UNIT_2P75: 22,
      UNIT_3: 24,
      UNIT_3P25: 26,
      UNIT_3P5: 28,
      UNIT_4: 32,
      UNIT_4P5: 36,
      UNIT_5: 40,
      UNIT_5P5: 44,
      UNIT_6: 48,
      UNIT_6P5: 52,
      UNIT_7: 56,
      UNIT_7P5: 60,
      UNIT_8: 64,
      UNIT_9: 72,
      UNIT_10: 80,
      UNIT_11: 88,
      UNIT_12: 96,
      UNIT_13: 104,
      UNIT_14: 112,
      UNIT_15: 120,
      UNIT_16: 128,
      UNIT_17: 136,
      UNIT_18: 144,
      UNIT_19: 152,
      UNIT_20: 160,
      UNIT_24: 192,
      UNIT_25: 200,
      UNIT_28: 224,
      UNIT_30: 240,
      UNIT_32: 256,
      UNIT_35: 280,
      UNIT_40: 320,
      UNIT_45: 360,
      UNIT_50: 400,
      UNIT_55: 440,
      UNIT_60: 480,
      UNIT_65: 520,
      UNIT_70: 560,
      UNIT_75: 600,
      UNIT_80: 640,
      UNIT_85: 680,
      UNIT_90: 720,
      UNIT_95: 760,
      UNIT_100: 800
    },
    COLOR: {
      MISC: { ALERT_SPACING_LEFT_ADJUSTEDFORFIGMABORDER: 28 }
    },
    BREAKPOINTS: {
      BREAKPOINT_XSMALL: 390,
      BREAKPOINT_SMALL: 576,
      BREAKPOINT_MEDIUM: 768,
      BREAKPOINT_LARGE: 992,
      BREAKPOINT_XLARGE: 1200,
      BREAKPOINT_2XLARGE: 1440,
      BREAKPOINT_3XLARGE: 1920,
      BREAKPOINT_UL: 2560
    }
  },
  CORE: {
    HEIGHTS: {
      INPUT_HEIGHTS: {
        SIZE_INPUT_HEIGHT_LARGE: 160,
        SIZE_INPUT_HEIGHT_MEDIUM: 128,
        SIZE_INPUT_HEIGHT_SMALL: 96
      }
    },
    WIDTHS: {
      SIZE_TOAST_WIDTH: 320,
      SINGLE_DIGIT_INPUT_WIDTHS: {
        SIZE_INPUT_SINGLEDIGIT_WIDTH_LARGE: 44,
        SIZE_INPUT_SINGLEDIGIT_WIDTH_MEDIUM: 36,
        SIZE_INPUT_SINGLEDIGIT_WIDTH_SMALL: 28
      },
      TOOLTIP_WIDTHS: {
        SIZE_TOOLTIP_WIDTH_SMALL: 192,
        SIZE_TOOLTIP_WIDTH_LARGE: 256
      },
      INPUT_WIDTHS: {
        SIZE_INPUT_WIDTH_SMALL: 96,
        SIZE_INPUT_WIDTH_MEDIUM: 200,
        SIZE_INPUT_WIDTH_LARGE: 320,
        SIZE_INPUT_WIDTH_XLARGE: 600
      },
      DROPDOWN_WIDTHS: {
        SIZE_DROPDOWN_WIDTH_DESKTOP: 224,
        SIZE_DROPDOWN_WIDTH_TABLET: 280
      },
      MODAL_WIDTHS: {
        SIZE_MODAL_WIDTH_SMALL: 400,
        SIZE_MODAL_WIDTH_MEDIUM: 600,
        SIZE_MODAL_WIDTH_LARGE: 800
      }
    },
    RADIUS: {
      SIZE_BORDER_RADIUS_OFFGRID_2: 2,
      SIZE_BORDER_RADIUS_SMALL: 4,
      SIZE_BORDER_RADIUS_OFFGRID_7: 7,
      SIZE_BORDER_RADIUS_MEDIUM: 8,
      SIZE_BORDER_RADIUS_OFFGRID_9: 9,
      SIZE_BORDER_RADIUS_OFFGRID_10: 10,
      SIZE_BORDER_RADIUS_OFFGRID_12: 12,
      SIZE_BORDER_RADIUS_OFFGRID_14: 14,
      SIZE_BORDER_RADIUS_LARGE: 16,
      SIZE_BORDER_RADIUS_OFFGRID_18: 18,
      SIZE_BORDER_RADIUS_OFFGRID_20: 20,
      SIZE_BORDER_RADIUS_OFFGRID_22: 22,
      SIZE_BORDER_RADIUS_XLARGE: 24,
      SIZE_BORDER_RADIUS_OFFGRID_26: 26
    },
    SPACING: {
      SPACING_OFFGRID_1: 1,
      SPACING_XSMALL: 2,
      SPACING_OFFGRID_3: 3,
      SPACING_SMALL: 4,
      SPACING_OFFGRID_6: 6,
      SPACING_MEDIUM: 8,
      SPACING_OFFGRID_9: 9,
      SPACING_OFFGRID_10: 10,
      SPACING_OFFGRID_12: 12,
      SPACING_LARGE: 16,
      SPACING_OFFGRID_20: 20,
      SPACING_XLARGE: 24,
      SPACING_2XLARGE: 32,
      FORMS_INPUT_SPACING_AFTER: 24,
      SPACING_3XLARGE: 40,
      SPACING_4XLARGE: 48,
      SPACING_8XLARGE: 64,
      TABLE_CELL_SPACING_PADDING: 12,
      TABLE_CELL_SPACING_PADDING_COMPACT: 6
    },
    BREAKPOINTS: {
      BREAKPOINTXS: 390,
      BREAKPOINTSM: 576,
      BREAKPOINTMD: 768,
      BREAKPOINTLG: 992,
      BREAKPOINTXL: 1200,
      BREAKPOINT2XL: 1440,
      BREAKPOINT3XL: 1920,
      BREAKPOINTUL: 2560
    }
  },
  DEVICES: {
    DESKTOP: {
      PADDING: {
        SPACING_RESPONSIVE_XSMALL: 8,
        SPACING_RESPONSIVE_SMALL: 16,
        SPACING_RESPONSIVE_MEDIUM: 24,
        SPACING_RESPONSIVE_LARGE: 32,
        SPACING_RESPONSIVE_XLARGE: 40
      },
      MISC: { ALERT_SIZE_BORDER_LEFT: 28 }
    },
    MOBILE: {
      PADDING: {
        SPACING_RESPONSIVE_XSMALL: 4,
        SPACING_RESPONSIVE_SMALL: 8,
        SPACING_RESPONSIVE_MEDIUM: 16,
        SPACING_RESPONSIVE_LARGE: 24,
        SPACING_RESPONSIVE_XLARGE: 32
      },
      MISC: { ALERT_SIZE_BORDER_LEFT: 20 }
    }
  },
  BRAND: {
    CMC: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 8,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 9,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 10,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 12,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 16,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 20,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 24,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    BENDIGO: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 8,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 9,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 10,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 12,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 16,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 20,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 24,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    ST_GEORGE: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    BOQ: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 0,
        WL_SIZE_PANEL_BORDER_RADIUS: 0
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    RIVKIN: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    ADVANTAGE: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 8,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 9,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 10,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 12,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 16,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 20,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 24,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    E_BROKING: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 8,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 9,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 10,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 12,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 16,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 20,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 24,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    ALPHA: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 8,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 9,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 10,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 12,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 16,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 20,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 24,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    UK: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 8,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 9,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 10,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 12,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 16,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 20,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 24,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 24
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    ASB: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 2
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 2,
        WL_SIZE_PANEL_BORDER_RADIUS: 2
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    ASB_2: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 2,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 2
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 2,
        WL_SIZE_PANEL_BORDER_RADIUS: 2
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    MARKETS_CMC: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 8,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 9,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 10,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 12,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 16,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 20,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 24,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    CONNECT: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 8,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 9,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 10,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 12,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 16,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 20,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 24,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    GREAT_SOUTHERN_BANK: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    },
    WESTPAC: {
      BRAND_RADIUS: {
        BUTTON_TAB_BADGE_RADIUS: {
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_8: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_9: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_CUSTOM_10: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_XSMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_SMALL: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_MEDIUM: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_LARGE: 3,
          WL_SIZE_BUTTONBADGETAB_BORDER_RADIUS_NONE: 0
        },
        WL_SIZE_INPUT_BORDER_RADIUS: 4,
        WL_SIZE_PANEL_BORDER_RADIUS: 8
      },
      BRAND_FOCUS_RING: { WL_SIZE_FOCUSRING_WIDTH_STROKE: 2 }
    }
  },
  TYPOGRAPHY: { VALUE: { NUMBER: 0 } }
} as const;

export type EuroaNumbers = typeof EORA_NUMBERS;
export type EuroaNumber = EuroaNumbers[keyof EuroaNumbers];
